export function getErrorMsg(err: any) {
	// Handle QuickBooks/accounting API errors with description field
	if (err.response?.data?.description) {
		return { message: "Error", description: err.response.data.description };
	}

	// Handle validation errors where message is an object with message array
	if (
		err.response?.data?.message?.message &&
		Array.isArray(err.response.data.message.message)
	) {
		return {
			message: "Validation Error",
			description: err.response.data.message.message[0],
		};
	}

	// Handle a coded refusal, e.g. 403 { message: { code, message } } from the
	// invite guards (INVITE_EXPIRED, INVITER_NOT_ADMIN).
	if (typeof err.response?.data?.message?.message === "string") {
		return { message: "Error", description: err.response.data.message.message };
	}

	// Handle other structured error responses
	if (
		err.response?.data?.message &&
		typeof err.response.data.message === "string"
	) {
		const msg = err.response.data.message;
		if (msg.includes("Firebase")) {
			return { message: "Error", description: parseFirebaseError(msg) };
		}
		return { message: "Error", description: msg };
	}

	// Handle array messages directly in response.data.message
	if (err.response?.data?.message && Array.isArray(err.response.data.message)) {
		return { message: "Error", description: err.response.data.message[0] };
	}

	// Fallback to generic error message
	const msg = err.message || err.toString();
	if (msg instanceof Array) {
		return { message: "Error", description: msg[0] };
	}

	if (msg.includes("Firebase")) {
		return { message: "Error", description: parseFirebaseError(msg) };
	}

	return { message: "Error", description: msg };
}

function parseFirebaseError(msg: string) {
	const type = msg.replace("Firebase: Error (", "").replace(").", "").trim();

	switch (type) {
		case "auth/user-not-found":
			return "Invalid email or password";
		case "auth/email-already-exists":
			return "Email not found or already exists";
		case "auth/wrong-password":
			return "Invalid email or password";
		case "auth/email-already-in-use":
			return "Email already in use. Please sign in";
		case "auth/invalid-credential":
			return "The provided credentials are invalid. Please try again.";
		default:
			return msg;
	}
}
